import { Component, type ReactNode } from "react";
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? (
      <main className="mx-auto max-w-lg p-8 pt-24">
        <h1 className="text-2xl font-semibold">This page could not load</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Reload to try again. If the problem continues, contact your
          administrator.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-6 rounded-lg bg-primary px-5 py-3 text-sm text-primary-foreground"
        >
          Reload page
        </button>
      </main>
    ) : (
      this.props.children
    );
  }
}
